import { useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import { getChartChrome, getRechartsTooltipProps } from "../../theme";

export function getMonitoringChartTheme(mode) {
  const chrome = getChartChrome(mode);
  const dark = mode === "dark";

  return {
    grid: chrome.grid,
    axisTick: { fontSize: 11, fill: chrome.tick },
    axisLine: { stroke: chrome.axisLine },
    tickLine: { stroke: chrome.axisLine },
    tooltip: dark
      ? {
          ...getRechartsTooltipProps(mode),
          cursor: {
            fill: "rgba(255,255,255,0.06)",
            stroke: chrome.axisLine,
            strokeWidth: 1,
          },
          wrapperStyle: { outline: "none" },
        }
      : {},
    legend: dark ? { wrapperStyle: { color: chrome.tick } } : {},
    expectedStroke: dark ? chrome.neutralSeries : "#90a4ae",
    expectedFill: dark ? "rgba(184,199,212,0.16)" : "#eceff1",
    expectedBar: dark ? "rgba(184,199,212,0.72)" : "#cfd8dc",
  };
}

export default function useMonitoringChartTheme() {
  const theme = useTheme();
  return useMemo(() => getMonitoringChartTheme(theme.palette.mode), [theme.palette.mode]);
}
